import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { isDp3Policy } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('overview-policy-type', []);

interface OverviewPolicyTypeController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    policyType: string;
}

module.component('overviewPolicyType', {
    bindings: {
        policyInfo: '<'
    },
    template: template,
    controller: function(this: OverviewPolicyTypeController, $element: angular.IAugmentedJQuery) {
        this.$onInit = function() {
            if (isDp3Policy(this.policyInfo)) {
                this.policyType = 'Landlord Policy';
            }
        };
    }
});

export { module };
